import { FunctionComponent, PropsWithChildren } from "react";

export const TableEmptyCell: FunctionComponent<PropsWithChildren> = (props) => {
    return <td className="cui-table__cell--empty">{props.children}</td>;
};
